import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import Tr from "translations/Translations";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import {getSectionVariant} from "../../../../constants/StageSections";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    offerDate: {
        marginLeft: theme.spacing(5),
        fontStyle: "italic"
    }
}))

function AdditionalOfferEditSectionTitle(
    {
        section
    }) {

    const classes = useStyle();

    return (<div>
            <GridBlock alignItems="center">
                <ExpansionPanelTitleAvatar variant={getSectionVariant(section)}/>
                <Typography variant='h6'>
                    {section.name}
                </Typography>
            </GridBlock>
            <GridBlock justify="space-between">
                {!!section.endDate &&
                    <Typography className={classes.offerDate}>
                        {Tr('additional_round_end_date')}: {moment(section.endDate).format(DateFormats.DATETIME_FORMAT)}
                    </Typography>
                }
                {!!section.offerTmpDate &&
                    <Typography className={classes.offerDate}>
                        {Tr('offer_tmp_date_additional')}: {moment(section.offerTmpDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                    </Typography>
                }

            </GridBlock>
        </div>
    )

}

AdditionalOfferEditSectionTitle.propTypes = {
    expanded: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        section: PropTypes.string.isRequired
    }).isRequired
}

export default AdditionalOfferEditSectionTitle;